import { render, staticRenderFns } from "./AIModels.vue?vue&type=template&id=296f6e19&scoped=true"
import script from "./AIModels.vue?vue&type=script&lang=js"
export * from "./AIModels.vue?vue&type=script&lang=js"
import style0 from "./AIModels.vue?vue&type=style&index=0&id=296f6e19&prod&scoped=true&lang=scss"
import style1 from "./AIModels.vue?vue&type=style&index=1&id=296f6e19&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296f6e19",
  null
  
)

export default component.exports